import { useEffect } from "react";
import Button from "../components/Button";
import { renderStrapiContent } from "../utils/contentfulOptions";
import FullPageLoader from "../components/FullPageLoader";
import Hero from "../images/cowtown/hero.jpg";
import SwooshLogo from "../images/cowtown/swoosh-logo.png";
import CardWagon from "../images/cowtown/card-wagon.jpg";
import CardRodeo from "../images/cowtown/card-rodeo.png";
import CardOutfitters from "../images/cowtown/card-outfitters.png";
import CardBrewery from "../images/cowtown/card-brewery.png";
import WineBottles from "../images/cowtown/wine-bottles.png";
import VisitNJ from "../images/cowtown/visitnj.png";
import Arrow from "../images/cowtown/arrow.png";

const TICKETS_URL = "https://www.exploretock.com/auburnroadvineyards/";
const RESERVATION_URL = "https://www.exploretock.com/auburnroadvineyards/";
const VIDEO_URL = "https://youtube.com/embed/TTYinQzJsZ0?si=MmZi-Cfxb1b2SbCY";

const PARTNER_DEFAULTS = [
  {
    match: /wagon|tour/i,
    title:
      "See the schedule and purchase your tickets for a Covered Wagon Tour",
    buttonText: "Get Tickets",
    link: TICKETS_URL,
    img: CardWagon,
  },
  {
    match: /rodeo/i,
    title: "Purchase tickets for Cowtown Rodeo",
    buttonText: "Get tickets",
    link: "https://cowtownrodeo.com/tickets/",
    img: CardRodeo,
  },
  {
    match: /outfitter/i,
    title: "Check out Cowtown Cowboy Outfitters",
    buttonText: "Check it out",
    link: "https://cowtowncowboy.com/",
    img: CardOutfitters,
  },
  {
    match: /brew/i,
    title: "Visit Bullhide Brewery",
    buttonText: "Check it out",
    link: "https://bullhidebrewery.com/",
    img: CardBrewery,
  },
];

const parseStrapiCards = (cards = []) =>
  cards
    .map((card) => {
      const description = card.description || "";
      const [buttonText, link] = description.split("-");
      return {
        title: card.Title || card.title,
        buttonText: buttonText?.trim(),
        link: link?.trim(),
      };
    })
    .filter((card) => card.title);

const buildPartnerCards = (strapiCards) => {
  const fromCms = parseStrapiCards(strapiCards);
  return PARTNER_DEFAULTS.map((def) => {
    const match = fromCms.find((card) => def.match.test(card.title || ""));
    return {
      title: match?.title || def.title,
      buttonText: match?.buttonText || def.buttonText,
      link: match?.link || def.link,
      img: def.img,
    };
  });
};

const renderHeading = (heading) => {
  if (!heading) return null;
  if (typeof heading === "string") {
    return <h1>{heading}</h1>;
  }
  return renderStrapiContent(heading);
};

const Cowtown = ({ info }) => {
  useEffect(() => {
    document.title = "Auburn Road - Cowtown Covered Wagon Tours";
    document.body.classList.add("cowtown-active");
    return () => {
      document.title = "Auburn Road Vineyards";
      document.body.classList.remove("cowtown-active");
    };
  }, []);

  if (!info) {
    return <FullPageLoader />;
  }

  const cards = buildPartnerCards(info.card);

  return (
    <div className="cowtown">
      <section className="cowtown-hero">
        <div className="cowtown-hero__stage">
          <img
            className="cowtown-hero__photo"
            src={Hero}
            alt="Guests on a covered wagon looking out at horses"
          />
          <img
            className="cowtown-hero__brand"
            src={SwooshLogo}
            alt="Cowtown NJ Covered Wagon Tours — Ridin' the trail from vineyard to brewery"
          />
        </div>
      </section>

      <section className="cowtown-main">
        <div className="container cowtown-main__inner">
          <div className="cowtown-intro">
            <div className="cowtown-intro__video">
              <div className="huge-text-no-quote cowtown-heading">
                {renderHeading(info.Heading)}
              </div>
              <Button href={TICKETS_URL} type="secondary" className="mb-4">
                Get Tickets
              </Button>
              <iframe
                src={VIDEO_URL}
                allowFullScreen
                title="Cowtown covered wagon tour video"
              />
            </div>
            <img className="cowtown-intro__arrow" src={Arrow} alt="" />
            <div className="cowtown-intro__copy">
              {renderStrapiContent(info.body)}
              <Button href={TICKETS_URL} type="brush">
                Get Tickets
              </Button>
              <p className="mt-1">
                See the schedule and purchase your <br /> tickets for a Covered
                Wagon Tour
              </p>
            </div>
          </div>

          <div className="cowtown-cards">
            {cards.map((card) => (
              <div className="cowtown-card" key={card.title}>
                <img src={card.img} alt={card.title} />
                <div className="cowtown-card__body">
                  <p>{card.title}</p>
                  <Button href={card.link} type="brush">
                    {card.buttonText}
                  </Button>
                </div>
              </div>
            ))}
          </div>
          <div className="cowtown-grant">
            <a
              href="https://www.visitnj.org/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <img src={VisitNJ} alt="visitnj.org" />
            </a>
            <p>
              Supported in part by a Grant from the NU Dept of State, Division
              of Travel and Tourism and the NU Dept of Agriculture.
            </p>
          </div>

          <div className="cowtown-reserve">
            <div className="cowtown-reserve__copy">
              <h2>Don't forget...</h2>
              <p>
                to make reservations for before or after your tour at Auburn
                Road!
              </p>
              <Button href={RESERVATION_URL} type="brush" className="mt-4">
                Make a Reservation
              </Button>
            </div>
            <img
              className="cowtown-reserve__wines"
              src={WineBottles}
              alt="Auburn Road wines"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Cowtown;
